import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  container: {
    mt: '80px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.down('md')]: {
      mt: '80px',
    },
  },

  textBox: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      width: '60%',
    },
  },

  title: {
    // mt: '120px',
  },

  text: {
    color: 'grey.600',
    fontSize: '16px',
    fontWeight: 400,
    mt: '40px',
    width: '50%',
    textAlign: 'center',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  button: {
    mt: '40px',
  },
});
